<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t(getTitle) }}</h1>
    <!-- form  -->
    <v-card outlined class="mb-4">
      <form @keydown.enter.prevent="submit()">
        <v-card-text class="mt-5">
          <v-row class="mb-0 pb-0">
            <v-col cols="12" md="6">
              <el-text-field
                autocomplete="off"
                label="Kodas"
                type="text"
                disabled
                v-model="nirvarLimit.nar_code"
              />
            </v-col>
            <v-col cols="12" md="6">
              <el-text-field
                autocomplete="off"
                label="NIRVAR srities pavadinimas"
                type="text"
                disabled
                v-model="nirvarLimit.name"
              />
            </v-col>
            <v-col cols="12" md="12">
              <el-textarea
                autocomplete="off"
                label="Komentaras"
                type="text"
                :disabled="view"
                :maxlength="500"
                v-model="nirvarLimit.comment"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <el-button
              class="mr-1"
              color="secondary"
              icon="atšaukti"
              title="Atšaukti"
              @click.native.stop="back()"
              :loading="loading"
            />
            <el-button
              v-if="!modeReadonly && !view"
              title="Išsaugoti"
              :loading="loading"
              @click.native="saveData()"
              color="primary"
              icon="išsaugoti"
            />
          </v-row>
        </v-card-actions>
      </form>
    </v-card>
    <!--  -->
    <v-card outlined class="mb-4" v-if="!iniLoadning">
      <form @keydown.enter.prevent="submit()">
        <v-card-text class="mt-5">
          <v-row class="mb-0 pb-0">
            <v-col cols="12" md="12" >
               <composite-list-select 
                label="Paslaugos ir veiksmai"
                sub-label="Pridėtos paslaugos"
                :items="classifiers['action-for-nirvar']" 
                v-model="selectedActions" 
                :disabled="view"
                @update-data="updateData"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </form>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import upload from '@/mixins/upload'
import CompositeListSelect from '@/views/classifiers/nirvarLimits/listSelect/CompositeListSelect.vue'

import { classifiersGet } from '@/services/classifierService.js'
export default {
  name: 'NirvarLimitForm',
  components: { CompositeListSelect },
  mixins: [userRole, upload],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      loadingActions: false,
      pageloading: false,
      classifiers: [],
      loading: false,
      nirvarLimit: {},
      selectedActions: [],
      iniLoadning: true
    }
  },
  computed: {
    view(){
      return !this.nirvarLimit.canEdit
    },
    modeReadonly() {
      return false
    },

    getId() {
      return this.$route.params.id || null
    },

    getTitle() {
      return this.$t(`Redaguoti NIRVAR sritį`)
    },
  },
  beforeDestroy() {},
  created() {
    this.getClassifiers()
    if (this.getId) {
      this.getData()
    }
  },
  methods: {
    updateData(){
      this.getData(true)
    },
    back() {
      this.$router.push({ name: 'nirvarLimit' })
    },
    async getData() {
      this.pageloading = true
      this.loadingActions = true
      this.$axios
        .get(`nirvar/${this.getId}`)
        .then((res) => {
          this.nirvarLimit = res.data.nirvarLimit
          this.selectedActions = res.data.nirvarLimit.actions.map((action) => String(action.id))
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loadingActions = false
          this.pageloading = false
          this.iniLoadning = false
        })
    },
    getClassifiers() {
      classifiersGet({ classifiers: ['action-for-nirvar']})
        .then(res => this.classifiers = res.data.classifiers)
        .catch(err => this.$root.$emit('DATA_ERROR', err))
        .finally()
    },
    saveData() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true

          let url = `nirvar/` + this.getId
          this.$axios
            .post(url, {
              "comment": this.nirvarLimit.comment || '',
              'actions': this.selectedActions
            })
            .then((res) => {
              this.$root.$emit('DATA_OK_CODE', '000110')
              this.back()
            })
            .catch((err) => {
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
